import { create } from "zustand";

// The three consents required to access protected features (health records,
// AI analysis, emergency data sharing). Mirrors the mobile app.
export const FEATURE_CONSENT_KEYS = ["healthDataCollection", "aiAnalysis", "emergencyDataSharing"];

const hasFeature = (c) => FEATURE_CONSENT_KEYS.every((k) => c[k] === true);

const DEFAULT = {
  terms_of_service: false,
  privacy_policy: false,
  healthDataCollection: false,
  aiAnalysis: false,
  emergencyDataSharing: false,
  personalizedRecommendations: false,
  analyticsTracking: false,
  promotionalMessages: false,
};

export const useConsentStore = create((set, get) => ({
  consents: { ...DEFAULT },
  hydrated: false,
  gateVisible: false,
  _resolve: null,

  hydrateFromServer: (consentMap) => {
    if (!consentMap) {
      set({ hydrated: true });
      return;
    }
    const next = { ...get().consents };
    Object.entries(consentMap).forEach(([type, val]) => {
      next[type] = !!val?.consented;
    });
    set({ consents: next, hydrated: true });
  },

  setConsents: (patch) => set({ consents: { ...get().consents, ...patch } }),

  hasFeatureConsent: () => hasFeature(get().consents),

  // Returns a promise resolving true when the user grants the 3 feature consents.
  openFeatureGate: () => {
    if (hasFeature(get().consents)) return Promise.resolve(true);
    return new Promise((resolve) => set({ gateVisible: true, _resolve: resolve }));
  },

  resolveGate: (granted) => {
    const r = get()._resolve;
    if (granted) {
      const next = { ...get().consents };
      FEATURE_CONSENT_KEYS.forEach((k) => (next[k] = true));
      set({ consents: next });
    }
    set({ gateVisible: false, _resolve: null });
    if (r) r(granted);
  },

  reset: () => set({ consents: { ...DEFAULT }, hydrated: false }),
}));
